<template>
  <div>
      <div class="row">
          <div class="col-sm-6 col-lg-3">
            <div class="card rounded-lg p-3">
              <h3 class="text-center">ReplyEngine</h3>
              <p>Connect your customers Google Business Profile and automatically respond to Google reviews in real time using AI.</p>
              <p>
                <a href="https://replyengine.io/replay" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
              </p>
              <div class="text-center">
                <button v-if="hasReplyEnginePlan" disabled type="button" class="btn btn-success"><i class="uil uil-check-square mr-2" />Purchased</button>
                <button v-else class="btn btn-primary" type="button"
                        @click="showSubscriptions('ReplyEngine')">Purchase</button>
              </div>
            </div>
          </div>
        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">TapEngine</h3>
            <p>Collect massive reviews for your customers using NFC cards. Track all employees & new Google reviews.</p>
            <p>
              <a href="https://tapengine.io/replay" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasTapEnginePlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('TapEngine')">Purchase</button>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">SocialReviews</h3>
            <p>Create images for Facebook and Instagram from your reviews and automatically post them to your account.</p>
            <p>
              <a href="https://getsocialreviews.com/private" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasSocialReviewPlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('SocialReview')">Purchase</button>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">ReviewSurge</h3>
            <p>Maximize your review generation efforts by creating tailored text and email series to prompt feedback from your valued customers.</p>
            <p>
              <a href="https://reviewsurge.co/rs-replay" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasReviewSurgePlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('ReviewSurge')">Purchase</button>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">Lead Machine</h3>
            <p>LeadMachine quickly builds direct mail campaigns with automated tools, real-time notifications, and detailed analytics.</p>
            <p>
              <a href="https://leadmachine.io/replay" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasLeadMachinePlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('LeadMachine')">Purchase</button>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">SocialFusion</h3>
            <p>AI-generated daily social media posts with images, texts and hastags to auto post to Facebook and Instagram.</p>
            <p>
              <a href="https://socialfusionai.com/replay" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasSocialFusionPlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('SocialFusion')">Purchase</button>
            </div>
          </div>
        </div>
        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">InstaStream</h3>
            <p>Effortlessly showcase your Instagram feed on any website with a sleek, fully customizable widget.</p>
            <p>
              <a href="https://instastream.co" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasInstaStreamPlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('InstaStream')">Purchase</button>
            </div>
          </div>
        </div>
<!--        <div class="col-sm-6 col-lg-3">
          <div class="card rounded-lg p-3">
            <h3 class="text-center">RepuAgency</h3>
            <p>Embed Google Reviews on your customers website in minutes for the Ultimate Social Proof!</p>
            <p>
              <a href="https://repuagency.com" target="_blank" style="color:#1f7fc4" class="font-size-17 font-weight-bold">View Details <i class="uil uil-angle-double-right" /></a>
            </p>
            <div class="text-center">
              <button v-if="hasRepuAgencyPlan" class="btn btn-success" disabled type="button"><i class="uil uil-check-square mr-2" />Purchased</button>
              <button v-else class="btn btn-primary" type="button"
                      @click="showSubscriptions('RepuAgency')">Purchase</button>
            </div>
          </div>
        </div>-->
      </div>
      <b-modal v-model="showSubscriptionModal" size="lg" :hide-footer="true">
        <Subscription :type-filter="filterSubscriptions" />
      </b-modal>
      <b-modal v-model="showKeyAlert" content-class="keymodal">
        <p><strong>Important:</strong> Enter Your OpenAI API Key</p>
        <p>To ensure the software works properly, please enter your OpenAI API key.</p>
        <p>If you need any assistance, feel free to reach out to <a href="mailto:support@molomedia.com">support@molomedia.com</a></p>
        <b-button variant="primary" @click="gotoSettings">Goto Settings</b-button>
      </b-modal>
  </div>
</template>

<script>
import Subscription from "@components/Agency/Subscription.vue";
export default {
  components: {
    Subscription,
  },
  data() {
    return {
      showSubscriptionModal:false,
      loadingSubscription:false,
      selectedPlan:null,
      addingCard:false,
      filterSubscriptions:null,
      showKeyAlert: false
    }
  },

  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
    hasReplyEnginePlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'ReplyEngine' || o.plan.planProducts.includes('ReplyEngine')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasTapEnginePlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'TapEngine' || o.plan.planProducts.includes('TapEngine')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasSocialReviewPlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'SocialReview' || o.plan.planProducts.includes('SocialReview')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasReviewSurgePlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'ReviewSurge' || o.plan.planProducts.includes('ReviewSurge')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasLeadMachinePlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'LeadMachine' || o.plan.planProducts.includes('LeadMachine')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasSocialFusionPlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'SocialFusion' || o.plan.planProducts.includes('SocialFusion')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasInstaStreamPlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'InstaStream' || o.plan.planProducts.includes('InstaStream')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    },
    hasRepuAgencyPlan(){
      return this.user?.user_plans && this.user.user_plans.filter(o => (o.plan.product_type === 'RepuAgency' || o.plan.planProducts.includes('RepuAgency')) && !o.past_due).length > 0 || (this.user.agency && this.user.agency.free_fee);
    }
  },
  mounted() {
    const hasSf = this.user?.user_plans && this.user.user_plans.filter(o => o.plan.product_type === 'SocialFusion' && !o.past_due).length || (this.user.agency && this.user.agency.free_fee);

    if(this.user.agency.settings.openai_api_key == null && hasSf){
      setTimeout(() => {
        this.showKeyAlert = true;
      }, 250);
    }
  },

  methods: {
    gotoSettings() {
      window.location.href = "/agency/settings";
    },
    showSubscriptions(which){
      this.filterSubscriptions = which;
      this.showSubscriptionModal = true;
    },
    subscription(plan) {
      this.selectedPlan = plan;
      if(this.user.default_payment_method){
        this.loadingSubscription = plan

        this.$store
            .dispatch('subscription/subscribe', plan)
            .then(() => {
              const that = this;
              setTimeout(function(){
                // TODO: Setup events instead of relying on a timeout
                that.loadingSubscription = null
                window.location.reload();
              },3000);
            })
            .catch(() => {
              this.loadingSubscription = null
            })
      }else{
        // this.showPaymentModal = true;
      }

    },
  },
}
</script>
<style lang="scss" scoped>
  .card p{
    max-width: 320px;
    display: block;
    margin: 0 auto 20px auto;
  }
</style>

<style>
.keymodal .modal-body{
    text-align: center !important;
    font-size: 17px !important;
    color: black !important;
  }
  .keymodal .modal-footer{
    display: none !important;
  }
  .keymodal .btn{
    font-weight: bold;
    font-size: 17px;
  }
</style>
